export default {
      id: "kmo-usage",
      viewBox: "0 0 502 146",
      url: "../../assets/" + "sprite.svg#kmo-usage",
      toString: function () {
        return this.url;
      }
    }